var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppMarket"},[_c('Banner'),(_vm.terminal == 'pc')?_c('Tabs'):_vm._e(),_c('App')],1)}
var staticRenderFns = []

export { render, staticRenderFns }